import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  DialogContent,
  TextField,
  LinearProgress,
  Menu,
  MenuItem,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  API_clone_bookings,
  API_delete_bookings_id,
  API_edit_booking,
  API_get_bookings,
  API_search_bookings,
} from "./utils/http";

import BorderColorRoundedIcon from "@mui/icons-material/BorderColorRounded";
import CopyAllRoundedIcon from "@mui/icons-material/CopyAllRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { DataGrid } from "@mui/x-data-grid";
import { checkOper_or_admin, DMY_to_YMD, idToTimeYYYYMMD } from "./utils/tool";
import FilterBooking from "./components/FilterBooking";
import {
  COLUMN_BOOKING,
  STATUS_CODE,
  TOKEN_USERNAME_APP,
} from "./utils/constDispatch";
import { AlertCus } from "./components/AlertCus";
import { getApiErrorMessage } from "./utils/apiError";
import { sortBookingsForRole } from "./utils/sortBooking";
import {
  PAGE_SIZE_BOOKING,
  nextVisibleCount,
  shouldLoadMore,
} from "./utils/infiniteScroll";
import { applySortModel } from "./utils/sortRows";
import AppBarSearchBox from "./components/SearchBox";
import { DialogCus } from "./components/DialogCus";
import InputLeft from "./InputLeft";
import OutputRight from "./components/pdf/OutputRight";
import NavbarSave from "./components/NavbarSave";

function ListBooking() {
  const theme = useTheme();
  // Cùng breakpoint với App.js, nơi sidebar chuyển sang drawer tạm.
  const isNarrow = useMediaQuery(theme.breakpoints.down("md"));

  const [data, set_data] = useState(null);
  const [data_filter, set_data_filter] = useState(null);
  const [search_text, set_search_text] = useState("");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const code = searchParams.get("code");

  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [new_bookings, setNewBookings] = useState("");

  const [clone_ok, set_clone_ok] = useState(null);
  const [delete_ok, set_delete_ok] = useState(null);
  const [delete_status, set_delete_status] = useState(null);

  const [api_status, set_api_status] = useState(null);
  const [status_change_ok, set_status_change_ok] = useState(null);
  const [status_change_error, set_status_change_error] = useState(null);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open_status = Boolean(anchorEl);
  const [density, setDensity] = React.useState("comfortable");

  // Số dòng đang hiện. Dữ liệu đã nằm sẵn trong data_filter (API chỉ gọi 1
  // lần), nên "tải thêm" ở đây chỉ là cho DataGrid render thêm dòng.
  const [visible_count, set_visible_count] = useState(PAGE_SIZE_BOOKING);
  const grid_box_ref = React.useRef(null);

  // Bảng chạy sortingMode="server": grid chỉ nhận cửa sổ dòng đã cắt, nên phải
  // tự sort trên toàn bộ dữ liệu, nếu không click header chỉ sắp được phần đã
  // tải. Rỗng = giữ thứ tự mặc định của sortBookingsForRole.
  const [sort_model, set_sort_model] = useState([]);

  const [filter_list, set_filter_list] = useState({
    mybooking: true,
    proceeding: true,
    dealing: true,
    sample: false,
    done: false,
    cancel: false,
    all: false,
  });

  const handleClose = () => setAnchorEl(null);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClickOpen = () => setOpen(!open);
  const handleClickOpen1 = () => {
    setOpen1(!open1);
  };

  const addDate = (x) => {
    let x_new = [];
    x.map((item) => {
      item.created_at = idToTimeYYYYMMD(item._id);
      if (item.day_start != null) {
        item.day_start = DMY_to_YMD(item.day_start);
      }
      if (item.day_end != null) {
        item.day_end = DMY_to_YMD(item.day_end);
      }
      x_new.push(item);
    });

    return x_new;
  };

  const get_data_booking = async () => {
    await API_get_bookings((x) => {
      if (x.success) {
        let x_new = addDate(x.data);
        set_data(x_new);

        x_new = apply_filters(x_new, filter_list);
        set_data_filter(x_new);
      }
    });
  };

  const confirmDelete = () => {
    handleClickOpen1();
    API_delete_bookings_id(selected_id, (x) => {
      set_delete_ok(x?.success);
      if (x?.success) {
        get_data_booking();
      } else {
        // Không dùng x.message thô: backend trả tiếng Anh ("you are not admin or
        // owner of this booking"), và khi mất mạng thì x là object Error nên
        // .message là chuỗi kỹ thuật.
        set_delete_status(getApiErrorMessage(x));
      }
    });
  };

  useEffect(() => {
    get_data_booking();
  }, []);

  const handle_search = async (search_text) => {
    if (search_text == "") {
      get_data_booking();
    } else {
      await API_search_bookings(search_text, (data_api) => {
        if (data_api.success) {
          let data_api_data = addDate(data_api.data);
          let x_filter = { all: true };
          let data_tmp = apply_filters(data_api_data, x_filter);

          set_data_filter(data_tmp);
          set_data(data_api_data);
        } else {
          set_data_filter(null);
          set_data(null);
        }
      });
    }
  };

  const [selected_id, set_selected_id] = useState(null);
  const [rowSelection, setRowSelection] = useState([]);

  useEffect(() => {
    if (code && data) {
      const row = data.find((r) => r.booking_number === code);
      if (row) {
        set_selected_id(row._id);
        setRowSelection([row._id]);
      }
    }
  }, [code, data]);

  const rows_all = React.useMemo(
    () => applySortModel(data_filter, sort_model),
    [data_filter, sort_model]
  );
  const total_rows = rows_all == null ? 0 : rows_all.length;

  // Cửa sổ dòng đưa cho DataGrid. paginationMode="server" nên grid render đúng
  // mảng này, không cắt trang thêm lần nữa.
  const rows_visible = React.useMemo(
    () => (rows_all == null ? [] : rows_all.slice(0, visible_count)),
    [rows_all, visible_count]
  );

  // Dữ liệu đổi (refresh, đổi filter, search, đổi cột sort, sau clone/delete/
  // đổi status) thì quay về 30 dòng đầu thay vì giữ số dòng đã cuộn lần trước.
  useEffect(() => {
    set_visible_count(PAGE_SIZE_BOOKING);
  }, [rows_all]);

  // Community DataGrid không có apiRef hay onRowsScrollEnd (Pro-only), nên bám
  // trực tiếp vào phần tử cuộn của bảng.
  useEffect(() => {
    const scroller = grid_box_ref.current?.querySelector(
      ".MuiDataGrid-virtualScroller"
    );
    if (scroller == null) return;

    const load_more = () => {
      if (shouldLoadMore(scroller, visible_count, total_rows)) {
        set_visible_count(nextVisibleCount(visible_count, total_rows));
      }
    };

    // Kiểm tra một lần sau khi layout xong: màn hình cao có thể chưa sinh
    // scrollbar, khi đó không có event scroll nào để chờ. requestAnimationFrame
    // để đo sau khi DataGrid đã dựng xong các dòng mới (row height auto).
    const raf = requestAnimationFrame(load_more);
    scroller.addEventListener("scroll", load_more);

    return () => {
      cancelAnimationFrame(raf);
      scroller.removeEventListener("scroll", load_more);
    };
  }, [visible_count, total_rows, density, rows_all]);

  const columns = COLUMN_BOOKING.map((col) => {
    if (col.field === "booking_number") {
      return {
        ...col,
        renderCell: (params) => (
          <span
            onClick={() =>
              navigate(
                "/booking?code=" + encodeURIComponent(params.value),
              )
            }
            style={{
              cursor: "pointer",
              color: "#1565C0",
              textDecoration: "underline",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "block",
            }}
          >
            {params.value}
          </span>
        ),
      };
    }
    return col;
  });

  // Tổng minWidth của 9 cột vẫn quá rộng cho màn hẹp, nên ở đó bỏ các cột phụ
  // thay vì để bảng scroll ngang.
  const column_visibility = {
    created_by: !isNarrow,
    customer_email: !isNarrow,
    day_end: !isNarrow,
    created_at: !isNarrow,
  };

  const change_status_booking = async (status) => {
    let body = { status: status };

    await API_edit_booking(selected_id, body, (x) => {
      set_status_change_ok(x?.success === true);
      if (x?.success) {
        get_data_booking();
      } else {
        // Previously silent: the list simply did not refresh, which reads as
        // "nothing happened" rather than "the server refused".
        set_status_change_error(getApiErrorMessage(x));
      }
    });
  };

  const MenuStatus = (status_str) => {
    return (
      <MenuItem
        onClick={(e) => {
          handleClose(e);
          change_status_booking(status_str);
        }}
      >
        {status_str}
      </MenuItem>
    );
  };

  const apply_filters = (data, x_filter) => {
    // Thứ tự mặc định khác nhau theo role: sale giữ thứ tự cũ, admin và
    // operator dùng thứ tự ưu tiên proceeding + travel date.
    const is_admin_oper = checkOper_or_admin();

    if (x_filter.all) {
      return sortBookingsForRole(data, is_admin_oper);
    }

    let data_tmp = data.filter((x) => {
      if (x_filter.proceeding && x.status == STATUS_CODE.proceeding) {
        return true;
      } else if (x_filter.dealing && x.status == STATUS_CODE.dealing) {
        return true;
      } else if (x_filter.sample && x.status == STATUS_CODE.sample) {
        return true;
      } else if (x_filter.done && x.status == STATUS_CODE.done) {
        return true;
      } else if (x_filter.cancel && x.status == STATUS_CODE.cancel) {
        return true;
      } else if (
        !x_filter.proceeding &&
        !x_filter.dealing &&
        !x_filter.sample &&
        !x_filter.done &&
        !x_filter.cancel &&
        x.status == null
      ) {
        return true;
      } else {
        return false;
      }
    });

    if (x_filter.mybooking) {
      data_tmp = data_tmp.filter((x) => {
        return x.created_by == sessionStorage.getItem(TOKEN_USERNAME_APP);
      });
    }

    return sortBookingsForRole(data_tmp, is_admin_oper);
  };

  const onChangeFilter = (x_filter) => {
    let data_tmp = apply_filters(data, x_filter);
    set_data_filter(data_tmp);
  };

  const onClickClone = () => {
    handleClickOpen();
    API_clone_bookings(selected_id, new_bookings, (e) => {
      console.log(e);
      set_clone_ok(e.success);
      if (e.success) {
        get_data_booking();
      } else {
        set_api_status(e.message);
      }
    });
  };

  // State for resizable divider
  const [leftPanelWidth, setLeftPanelWidth] = useState(50); // percentage
  const containerRef = React.useRef(null);
  const dividerRef = React.useRef(null);

  // Handle mouse events for resizing
  const startResize = (e) => {
    e.preventDefault();

    const startX = e.clientX;
    const startWidth = leftPanelWidth;

    const onMouseMove = (moveEvent) => {
      if (!containerRef.current) return;

      const containerWidth = containerRef.current.offsetWidth;
      const deltaX = moveEvent.clientX - startX;
      const newWidthPercent = startWidth + (deltaX / containerWidth) * 100;

      // Limit the resize range (10% to 90%)
      if (newWidthPercent >= 10 && newWidthPercent <= 90) {
        setLeftPanelWidth(newWidthPercent);
      }
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
      if (dividerRef.current) {
        dividerRef.current.style.backgroundColor = "#e0e0e0";
      }
    };

    // Change divider color during drag
    if (dividerRef.current) {
      dividerRef.current.style.backgroundColor = "#2196f3";
    }

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  const open_details = Boolean(code && selected_id);

  if (code && !selected_id && data === null) {
    return (
      <Box sx={{ width: "100%", marginTop: 10 }}>
        <LinearProgress />
      </Box>
    );
  }

  if (code && !selected_id && data !== null) {
    return (
      <Box sx={{ width: "100%", marginTop: 10, textAlign: "center" }}>
        <Typography>Booking "{code}" not found</Typography>
      </Box>
    );
  }

  if (open_details) {
    return (
      <Box
        sx={{
          height: { xs: "calc(100vh - 48px)", md: "100vh" },
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <NavbarSave
          booking_id={selected_id}
          title={"Booking details "}
          onGoBack={() => {
            navigate("/booking");
            get_data_booking();
          }}
        />
        <Box
          ref={containerRef}
          style={{
            display: "flex",
            width: "100%",
            flex: 1,
            minHeight: 0,
            overflow: "hidden",
          }}
        >
          <Box
            style={{
              width: `${leftPanelWidth}%`,
              height: "100%",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <InputLeft booking_id={selected_id} />
          </Box>

          <Box
            ref={dividerRef}
            style={{
              width: "8px",
              cursor: "col-resize",
              backgroundColor: "#e0e0e0",
              height: "100%",
              position: "relative",
              userSelect: "none",
              touchAction: "none",
              flexShrink: 0,
              zIndex: 10,
            }}
            // onMouseDown={startResize}
          >
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "4px",
                height: "30px",
                backgroundColor: "#bdbdbd",
                borderRadius: "2px",
              }}
            />
          </Box>

          <Box
            style={{
              width: `${100 - leftPanelWidth - 0.5}%`,
              height: "100%",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <OutputRight booking_id={selected_id} />
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    // Cột cao đúng viewport: chỉ DataGrid được scroll, nên trang không sinh
    // thêm scrollbar thứ hai bên ngoài scrollbar của bảng.
    // Mobile có thêm AppBar 48px của App.js nằm trên main.
    <Box
      sx={{
        height: { xs: "calc(100vh - 48px)", md: "100vh" },
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <AlertCus condition={clone_ok} message="Clone" error_text={api_status} />
      <AlertCus
        condition={delete_ok}
        message="delete"
        error_text={delete_status}
      />
      <AlertCus
        condition={status_change_ok}
        message="change status"
        error_text={status_change_error}
      />
      <AppBarSearchBox
        title="Booking"
        value={search_text}
        onChange={(e) => {
          if (e.target.value == "") {
            // handle_search("");
            set_selected_id(null);
          }
          set_search_text(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handle_search(search_text);
            set_selected_id(null);
          }
        }}
      />

      {data_filter != null ? (
        <Box
          sx={{
            padding: "16px 20px",
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 10,
              marginBottom: 16,
              flexShrink: 0,
            }}
          >
            {/* Ẩn footer là mất luôn row count của DataGrid, nên hiện lại ở đây. */}
            <Typography
              variant="body2"
              sx={{ marginRight: "auto", color: "#6B7280", fontSize: 13 }}
            >
              {"Đang hiện " +
                Math.min(visible_count, total_rows) +
                " / " +
                total_rows +
                " booking"}
            </Typography>

            <Button
              size="small"
              variant="outlined"
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 13,
              }}
              onClick={() => get_data_booking()}
            >
              Refresh
            </Button>

            <Button
              size="small"
              disabled={selected_id == null}
              variant="outlined"
              disableElevation
              endIcon={<BorderColorRoundedIcon sx={{ fontSize: 16 }} />}
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 13,
              }}
              onClick={(e) => {
                handleClick(e);
              }}
            >
              Status
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open_status}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              {MenuStatus(STATUS_CODE.proceeding)}
              {MenuStatus(STATUS_CODE.dealing)}
              {MenuStatus(STATUS_CODE.cancel)}
            </Menu>

            <Button
              size="small"
              disabled={selected_id == null}
              variant="contained"
              endIcon={<CopyAllRoundedIcon sx={{ fontSize: 16 }} />}
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 13,
              }}
              onClick={() => handleClickOpen()}
            >
              Clone
            </Button>
            <Button
              size="small"
              variant="outlined"
              disabled={selected_id == null}
              color="error"
              endIcon={<DeleteRoundedIcon sx={{ fontSize: 16 }} />}
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 13,
              }}
              onClick={() => handleClickOpen1()}
            >
              Delete
            </Button>
          </Box>

          <FilterBooking
            filter_list={filter_list}
            set_filter_list={(e) => {
              set_filter_list(e);
              onChangeFilter(e);
            }}
          />

          <DialogCus
            open={open1}
            title="Confirm delete"
            handleClickOpen={handleClickOpen1}
            handleClickConfirm={confirmDelete}
          ></DialogCus>

          <DialogCus
            open={open}
            title="Clone"
            handleClickOpen={handleClickOpen}
            handleClickConfirm={onClickClone}
          >
            <DialogContent>
              <TextField
                autoFocus
                value={new_bookings}
                onChange={(e) => setNewBookings(e.target.value)}
                margin="dense"
                id="name"
                label="booking number"
                fullWidth
                variant="standard"
              />
            </DialogContent>
          </DialogCus>
          <Box
            ref={grid_box_ref}
            sx={{
              flex: 1,
              minHeight: 0,
              width: "100%",
              "& .MuiDataGrid-root": {
                border: "1px solid #E0E0E0",
                borderRadius: "10px",
                overflow: "hidden",
                fontSize: 13,
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#F5F7FA",
                fontSize: 13,
                fontWeight: 600,
                color: "#555",
                borderBottom: "1px solid #E0E0E0",
              },
              "& .MuiDataGrid-row": {
                "&:hover": {
                  backgroundColor: "#F8FBFF",
                },
                "&.Mui-selected": {
                  backgroundColor: "#EBF4FF",
                  "&:hover": {
                    backgroundColor: "#DDEEFF",
                  },
                },
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #F0F0F0",
                py: 1,
              },
            }}
          >
            <DataGrid
              getRowId={(item) => item._id}
              rows={rows_visible}
              columns={columns}
              // Community DataGrid buộc pagination = true và throw khi pageSize
              // > 100, nên không thể coi cả danh sách là một trang dài. Ở
              // paginationMode="server" grid render đúng mảng rows được truyền
              // (useGridVisibleRows), nên cửa sổ dòng do rows_visible quyết
              // định và footer phân trang bị ẩn.
              paginationMode="server"
              rowCount={total_rows}
              sortingMode="server"
              sortModel={sort_model}
              onSortModelChange={set_sort_model}
              // Filter panel của grid chỉ lọc được cửa sổ đã tải, mà trang đã
              // có FilterBooking riêng, nên tắt để không lọc nửa vời.
              disableColumnFilter
              hideFooter
              columnVisibilityModel={column_visibility}
              getRowHeight={(params) => "auto"}
              rowSelectionModel={rowSelection}
              onRowSelectionModelChange={(e) => {
                setRowSelection(e);
                set_selected_id(e[0]);
              }}
              density={density}
              onDensityChange={(newDensity) => {
                setDensity(newDensity);
              }}

            />
          </Box>
        </Box>
      ) : (
        <Box sx={{ width: "100%", marginTop: 10 }}>
          <LinearProgress />
        </Box>
      )}
    </Box>
  );
}

export default ListBooking;
